import { DashboardUserRole } from '../../common/enums/DashboardUserRole';

export const isAdmin = (userRole?: string): boolean => {
  if (!userRole) return false;
  return (
    userRole === DashboardUserRole.Admin ||
    userRole === DashboardUserRole.SuperAdmin
  );
};

export const isSuperAdmin = (userRole?: string): boolean => {
  if (!userRole) return false;
  return userRole === DashboardUserRole.SuperAdmin;
};
